var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import * as ViewModel from "../../../models/ViewModel";
import { ViewHelper } from "../ViewHelper";
var CalculatedPeriodHelper = /** @class */ (function () {
    function CalculatedPeriodHelper() {
        this.viewHelperDependency = ViewHelper.getInstance();
    }
    CalculatedPeriodHelper.getInstance = function () {
        if (!this.instance) {
            this.instance = new CalculatedPeriodHelper();
        }
        return this.instance;
    };
    CalculatedPeriodHelper.prototype.setCurrentUserInfo = function (currentUserInfo) {
        this.currentUserInfo = currentUserInfo;
    };
    CalculatedPeriodHelper.prototype.setViewHelperDependency = function (viewHelper) {
        this.viewHelperDependency = viewHelper;
    };
    CalculatedPeriodHelper.prototype.wrappedCalculatedPeriodsStateless = function (stake, pulseBetMetadata, bonusInfo) {
        var numberOfPeriods = pulseBetMetadata.periods.length;
        var percentOfEachPeriod = 100 / numberOfPeriods;
        var result = [];
        for (var index = 0; index < pulseBetMetadata.periods.length; index++) {
            var calculatedPeriod = this.transformPeriodToCalculatedPeriodStateless(pulseBetMetadata.periods[index], index, stake, pulseBetMetadata, percentOfEachPeriod, bonusInfo);
            calculatedPeriod.absolutePercentFromTotal = calculatedPeriod.relativePercentFromTotal + (index > 0 ? result[index - 1].absolutePercentFromTotal : 0);
            result.push(calculatedPeriod);
        }
        ;
        return result;
    };
    CalculatedPeriodHelper.prototype.formatWinnings = function (winnings) {
        var formattedWinnings = "" + winnings;
        if (this.currentUserInfo) {
            formattedWinnings = this.currentUserInfo.toUserFormatedCurrencyString(winnings);
        }
        formattedWinnings = formattedWinnings.replace(/\s+/g, ""); //remove all space
        var winningValue = formattedWinnings.match(/[0-9-.]+/ig);
        if ((formattedWinnings.match(/\./g) || formattedWinnings.match(/\,/g)) && winningValue && winningValue[0]) {
            var p = winningValue[0].replace(/0*$|\.0+$/g, ""); //remove all trailing zeros
            formattedWinnings = formattedWinnings.replace(/[0-9-.]+/ig, p);
        }
        return formattedWinnings;
    };
    CalculatedPeriodHelper.prototype.transformPeriodToCalculatedPeriodStateless = function (p, index, stake, pulseBetMetadata, percentOfEachPeriod, bonusInfo) {
        var calculatedWin = Math.floor(+(stake * p.europeanOdds * 100).toPrecision(12)) / 100;
        calculatedWin = bonusInfo && !bonusInfo.isRiskFreeBet ? calculatedWin - bonusInfo.amount : calculatedWin;
        var calculated = new ViewModel.CalculatedPeriod({
            index: index,
            isLast: index + 1 === pulseBetMetadata.periods.length,
            period: p,
            calculatedWin: calculatedWin,
            formatedWin: this.formatWinnings(calculatedWin),
            periodDurationInMilli: p.endTimeInMilli - p.startTimeInMilli,
            relativePercentFromTotal: percentOfEachPeriod,
            absolutePercentFromTotal: percentOfEachPeriod * (index + 1),
            invertedStartTimeInMinutesFormat: this.viewHelperDependency.milliToMinutesString(pulseBetMetadata.durationInMilli - p.startTimeInMilli),
            relativeRangeFormatted: this.viewHelperDependency.milliRangeToMinutesRange(p.startTimeInMilli, p.endTimeInMilli, pulseBetMetadata.typeId),
            absoluteToGameFormattedGameStart: "",
            absoluteGameFormattedGameEnd: "",
            absoluteToGameStartInMilli: 0,
            absoluteToGameEndInMilli: 0,
        });
        return calculated;
    };
    CalculatedPeriodHelper.prototype.wrappedCalculatedPeriods = function (stake, pulseBetMetadata) {
        var e_1, _a;
        var result = this.wrappedCalculatedPeriodsStateless(stake, pulseBetMetadata);
        try {
            for (var result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                var period = result_1_1.value;
                period.absoluteToGameStartInMilli = period.period.startTimeInMilli;
                period.absoluteToGameEndInMilli = period.period.endTimeInMilli;
                period.absoluteToGameFormattedGameStart = this.viewHelperDependency.milliToMinutesString(period.absoluteToGameStartInMilli);
                period.absoluteGameFormattedGameEnd = this.viewHelperDependency.milliToMinutesString(period.absoluteToGameEndInMilli);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (result_1_1 && !result_1_1.done && (_a = result_1.return)) _a.call(result_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        ;
        return result;
    };
    return CalculatedPeriodHelper;
}());
export { CalculatedPeriodHelper };
//# sourceMappingURL=CalculatedPeriodHelper.js.map